/**
 * Constants that sieve uses to format their "filter" url
 */
export const SIEVE_CONSTANTS = {
  // names for sieve "parts"
  page: "page",
  pageSize: "pageSize",
  filters: "filters",
  sorts: "sorts",

  // split character defined to split values
  valueSplitChar: "|",

  // split character defined to split keys
  keySplitChar: "|",

  // split character defined to split "items" (multiple sorts, multiple filters)
  splitChar: ",",
};
